import { render, staticRenderFns } from "./MultipleImgPicker.vue?vue&type=template&id=3aafd455&scoped=true"
import script from "./MultipleImgPicker.vue?vue&type=script&lang=js"
export * from "./MultipleImgPicker.vue?vue&type=script&lang=js"
import style0 from "./MultipleImgPicker.vue?vue&type=style&index=0&id=3aafd455&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aafd455",
  null
  
)

export default component.exports